import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
} from "reactstrap";
import PageBody from "../../../components/PageBody";
import IconEdit from "../../../assets/images/icon-edit.png";
import Select from "react-select";
import { useHistory } from "react-router";
import ModalPopup from "../../../components/ModalPopup";
import CustomerAdd from "../../customer/CustomerAdd";
import IconCheckbox from "../../../assets/images/icon-checkbox.png";
import IconCheckboxActive from "../../../assets/images/icon-checkbox-active.png";
import NumberFormat from "react-number-format";
import TextUtils from "../../../helpers/TextUtils";
import styled from "styled-components";
import Flatpickr from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import IconCalendar from "../../../assets/images/icon/ic_calendar-black.svg";

const shipping_address_types:any = [
  {
    label:"Nội thành",
    value: 'inner'
  },
  {
    label:"Ngoại thành",
    value: 'outer'
  }
]

const OrderAddInfo = (props: any) => {
  const {
    data,
    setData,
    type,
    onlyView,
    orderSource,
    shippingPartner,
    product,
    payment,
    user,
    loadBranch
  } = props;
  const router = useHistory();
  const [modalIsOpen, setIsOpen] = useState(false);
  

  const handleChangeInput = (event?: any) => {
    let { value, name } = event.target;
    if (value === " ") return;
    if (value?.length > 1000) return;
    if (name === "phone") {
      value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "");
      setData({
        ...data,
        customer_id: {
          ...data?.customer_id,
          phone: value,
        },
      });
    } else {
      setData({
        ...data,
        [name]: value,
      });
    }
  };

  const calTotal = () => {
    let total: any = {
        count: 0,
        total: 0,
        discount: 0,
        discount_service: 0
    }
    total = product?.reduce((prev: any, item: any) => {
        const totalItem = Number(item?.price || 0)
        const discount = item?.discount_type === 'price' ? Number(item?.discount_value || 0) :
            totalItem * Number(item?.discount_value || 0) / 100
        const discount_service = data?.orderspackage?.product_type?.map((value: any) => {
        if(value == item?.product?.product_type) {
            if(Number(data?.orderspackage?.discount_order) > 0) {
                return (totalItem - discount) * Number(data?.orderspackage?.discount_order) / 100
            }else {
                return 0
            }
        }else {
            return 0
        }
        })
        const total_discount_service = discount_service?.reduce((prev: any, item: any) => {
            return prev + item
        },0)
        prev.discount_service += total_discount_service * Number(item?.quantity || 0)
        prev.total += totalItem * Number(item?.quantity || 0)
        prev.discount += discount * Number(item?.quantity || 0)
        prev.count += Number(item?.quantity || 0)
        return prev
    }, total)
    const sub_total = Number(total?.total || 0) - Number(total?.discount || 0)
    const discount = data?.discount_type === 'price' ? Number(data?.discount_value || 0) :
        sub_total * Number(data?.discount_value || 0) / 100
    const shipping_fee = Number(data?.shipping_fee || 0)
    const sub_total_end = Number(sub_total || 0) - Number(discount || 0) + shipping_fee - (total?.discount_service || 0)
    total.sub_total = sub_total
    total.sub_total_end = sub_total_end
    return total
  }
  
  const calTotalPayment = () => {
    const totalPayment = payment?.reduce((prev: any, item: any) => {
      if (item?.payment_total) prev = prev + Number(item?.payment_total);
      return prev;
    }, 0);
    return Math.floor(totalPayment || 0);
  };

  useEffect(() => {
    const totalPayment = calTotalPayment();
    const total = calTotal();
    const totalDiscountC = () => {
      let total_discount: any = {
          // chiết khấu gói C
          // số tiền trừ gói C
          // số tiền khách cần trả
          // số tiền khách cần trả trong trường hợp gói C bằng 0
          discountC: 0,
          discountCardC: 0,
          total_customer: 0,
      }
      if (product?.length > 0) {
          total_discount = product.reduce((prev: any, item: any) => {
              prev.discountC += item?.discountC || 0;
              prev.discountCardC += item?.priceDiscountC || 0;
              return prev;
          }, total_discount);
      }
      // phí ship
      const shipping_fee = Number(data?.shipping_fee || 0)
      // giảm giá trên tổng đơn
      const discount = data?.discount_type === 'price' ? Number(data?.discount_value || 0) :
          total.sub_total * Number(data?.discount_value || 0) / 100;
      let total_customer = 0;
      let discountCardC = Number(total_discount?.discountCardC || 0) - (Number(discount) || 0) + (Number(shipping_fee) || 0);
       if(Number(discountCardC || 0) <= (Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used || 0))) {
          // total_customer = Number(data?.orderspackage?.total_group || 0) - Number(total_discount.discountCardC || 0) - (Number(discount) || 0) + (Number(shipping_fee) || 0)
          total_customer = 0
      } else {
          if(type == 'view') {
              total_customer = Number(discountCardC || 0) - (Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used))
          }else {
              // if(data?.id) {
              //     // case chỉnh sửa
              //     total_customer = Number(discountCardC || 0) - (Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used || 0))
              // }else {
                  // case add
                  total_customer = Number(discountCardC || 0) - (Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used || 0))
              // }
              
          }
      }
      total_discount.total_customer = total_customer
      total_discount.discountCardC = discountCardC
      return total_discount;
    }
    const total_discount_c = totalDiscountC();
    let totalPaymentLeft = 0;
    if(data?.orderspackage?.type == 'account_card' && type == 'view') {
      if(Number(data?.total_group_package || 0) > Number(data?.total_package_used || 0)) {
        totalPaymentLeft = 0
      }else {
        totalPaymentLeft = total_discount_c?.total_customer - totalPayment
      } 
    } else if(data?.orderspackage?.type == 'account_card') {
      totalPaymentLeft = total_discount_c?.total_customer - totalPayment
    } else {
      totalPaymentLeft = total?.sub_total_end - totalPayment;
    }
    const shipping_cod = Number(data?.shipping_cod || 0);
    // if(!shipping_cod){
    setData({
      ...data,
      shipping_cod: totalPaymentLeft,
    });
    // }
  }, [product, data?.shipping_fee, data?.discount_value, payment, data?.orderspackage]);
  const branchs = props?.branch
 
  return (
    <>
      <PageBody>
        <div className="nutri-title mb-3">Thông tin vận chuyển</div>
        <Row>
          <Col md={12} xs={12}>
            <FormGroup className={type != "view" ? "placeholder-right1" : ""}>
              <div className="order-total-row mb-3">
                <ValueTextLabel>
                  <div
                    className="nutri-checkbox"
                    onClick={() => {
                      if (type == "view") return;
                      const status = data?.shipping_status ? false : true;

                      if (!status) {
                        setData({
                          ...data,
                          shipping_status: status,
                          shipping_partner_id: "",
                          shipping_code: "",
                          shipping_fee: "",
                          shipping_fee_free: "",
                          desired_time_receive: "",
                          shipping_cod: "",
                          shipping_note: "",
                        });
                      } else {
                        setData({
                          ...data,
                          shipping_status: status,
                        });
                      }
                    }}
                  >
                    <div className="icon">
                      {data?.shipping_status ? (
                        <img src={IconCheckboxActive} alt="icon" />
                      ) : (
                        <img src={IconCheckbox} alt="icon" />
                      )}
                    </div>
                    <div className="label">Vận chuyển</div>
                  </div>
                </ValueTextLabel>
                {/* {data?.shipping_status && (
                  <div style={{ flex: 1 }}>
                    <Select
                      placeholder="Chọn đơn vị"
                      className="react-select select-icon select-full"
                      classNamePrefix="react-select"
                      maxMenuHeight={250}
                      isDisabled={onlyView}
                      onChange={(val: any) => {
                        
                        setData({
                          ...data,
                          shipping_partner_id: val?.id,
                        });
                      }}
                      value={shippingPartner?.filter(
                        (option: any) =>
                          data?.shipping_partner_id == option.value
                      )}
                      options={shippingPartner}
                    ></Select>
                  </div>
                )} */}
              </div>
              {data?.shipping_status && (
                <>
                  <div className="order-total-row mb-3">
                    <ValueTextLabel>Khu vực vận chuyển</ValueTextLabel>
                    <ValueTextLabel>
                      <div style={{ flex: 1 }}>
                        <Select
                          placeholder="Chọn khu vực vận chuyển"
                          className="react-select select-icon select-full"
                          classNamePrefix="react-select"
                          maxMenuHeight={250}
                          isDisabled={onlyView}
                          onChange={(val: any) => {
                            setData({
                              ...data,
                              shipping_address_type: val.value,
                            })
                          }}
                          value={shipping_address_types.filter(
                            (option: any) =>
                              data?.shipping_address_type == option.value
                          )}
                        options={shipping_address_types}
                        ></Select>
                      </div>
                    </ValueTextLabel>
                  </div>
                  <div className="order-total-row mb-3">
                    <ValueTextLabel>Đơn vị vận chuyển</ValueTextLabel>
                    <ValueTextLabel>
                      <div style={{ flex: 1 }}>
                        <Select
                          placeholder="Chọn đơn vị"
                          className="react-select select-icon select-full"
                          classNamePrefix="react-select"
                          maxMenuHeight={250}
                          isDisabled={onlyView}
                          onChange={(val: any) => {
                            setData({
                              ...data,
                              shipping_partner_id: val?.id,
                              branch_id: null,
                            });
                            loadBranch(val?.id)
                          }}
                          value={shippingPartner?.filter(
                            (option: any) =>
                              data?.shipping_partner_id == option.value
                          )}
                          options={shippingPartner}
                        ></Select>
                      </div>
                    </ValueTextLabel>
                  </div>
                  <div className="order-total-row mb-3">
                    <ValueTextLabel>Kho xuất</ValueTextLabel>
                    <ValueTextLabel>
                      <div style={{ flex: 1 }}>
                        <Select
                          placeholder="Chọn kho"
                          className="react-select select-icon select-full"
                          classNamePrefix="react-select"
                          maxMenuHeight={250}
                          isDisabled={onlyView}
                          onChange={(val: any) => {
                            setData({
                              ...data,
                              branch_id: val.value
                            })
                          }}
                          value={branchs.filter(
                            (option: any) =>
                              data?.branch_id == option.value
                          )}
                        options={branchs}
                        ></Select>
                      </div>
                    </ValueTextLabel>
                  </div>
                  <div className="order-total-row mb-3">
                    <ValueTextLabel>Mã vận chuyển</ValueTextLabel>
                    <ValueTextLabel>
                      <Input
                        type="text"
                        className="form-control"
                        value={data?.shipping_code}
                        onChange={(e: any) => handleChangeInput(e)}
                        name="shipping_code"
                        placeholder="Nhập mã vận chuyển"
                      />
                    </ValueTextLabel>
                  </div>
                  <div className="order-total-row mb-3">
                    <ValueTextLabel>
                      Phí vận chuyển
                      <div
                        className="nutri-checkbox ml-4"
                        onClick={() => {
                          if (type == "view") return;
                          const status = data?.shipping_fee_free ? false : true;
                          setData({
                            ...data,
                            shipping_fee_free: status,
                            shipping_fee: status ? 0 : data?.shipping_fee,
                          });
                        }}
                      >
                        <div className="icon">
                          {data?.shipping_fee_free ? (
                            <img src={IconCheckboxActive} alt="icon" />
                          ) : (
                            <img src={IconCheckbox} alt="icon" />
                          )}
                        </div>
                        <div className="label">Miễn phí</div>
                      </div>
                    </ValueTextLabel>
                    <div style={{ flex: 1 }}>
                      <NumberFormat
                        onChange={(e: any) => {
                          let value = TextUtils.onlyNumber(e.target.value);
                          handleChangeInput({
                            target: { name: "shipping_fee", value: value },
                          });
                          setData({
                            ...data,
                            shipping_fee: value,
                            shipping_fee_free: value === 0 ? true : false,
                          });
                        }}
                        name={"shipping_fee"}
                        type={"text"}
                        className="form-control"
                        value={
                          type === "view" && !data?.shipping_fee
                            ? "---"
                            : data?.shipping_fee
                        }
                        disabled={onlyView}
                        placeholder={
                          type == "view" && !data?.shipping_fee
                            ? "---"
                            : "Nhập giá trị..."
                        }
                        thousandSeparator={true}
                      />
                    </div>
                  </div>
                  <div className="order-total-row mb-3">
                    <ValueTextLabel>Thời gian giao mong muốn</ValueTextLabel>
                    <ValueTextLabel>
                      <div style={{ position: "relative", flex: 1 }}>
                        <Flatpickr
                          value={[new Date(data?.desired_time_receive)]}
                          onChange={(date: any) => {
                            handleChangeInput({
                              target: {
                                name: "desired_time_receive",
                                value: date[0]
                                  ? moment(date[0]).valueOf()
                                  : undefined,
                              },
                            });
                          }}
                          options={{
                            locale: Vietnamese,
                            allowInput: true,
                            enableTime: true,
                            dateFormat: "d/m/Y H:i",
                            altInputClass: "date-range",
                            // minDate:'today'
                          }}
                          className="form-control"
                          placeholder="dd/mm/yy HH:mm"
                        />
                        {type != "view" && (
                          <InputGroupAddon
                            addonType="append"
                            className="d-flex align-items-center"
                            style={{ right: 12 }}
                          >
                            <img src={IconCalendar} alt="icon" />
                          </InputGroupAddon>
                        )}
                      </div>
                    </ValueTextLabel>
                  </div>
                  <div className="order-total-row mb-3">
                    <ValueTextLabel
                      style={{
                        fontSize: 20,
                        color: "#eda119",
                        fontWeight: 600,
                      }}
                    >
                      Tiền thu hộ
                    </ValueTextLabel>
                    <ValueTextLabel>
                      <NumberFormat
                        onChange={(e: any) => {
                          let value = TextUtils.onlyNumber(e.target.value);
                          handleChangeInput({
                            target: { name: "shipping_cod", value: value },
                          });
                        }}
                        name={"shipping_cod"}
                        type={"text"}
                        className="form-control font-size-24"
                        value={
                          type === "view" && !data?.shipping_cod
                            ? "---"
                            : data?.shipping_cod
                        }
                        disabled={onlyView}
                        placeholder={
                          type == "view" && !data?.shipping_cod
                            ? "---"
                            : "Nhập giá trị..."
                        }
                        thousandSeparator={true}
                      />
                    </ValueTextLabel>
                  </div>
                  <div className="order-total-row mb-3">
                    <Input
                      type="textarea"
                      rows={4}
                      value={data?.shipping_note}
                      onChange={(e: any) => handleChangeInput(e)}
                      name="shipping_note"
                      placeholder={
                        type === "view" && !data?.note
                          ? "---"
                          : "Nhập ghi chú vận chuyển"
                      }
                    />
                  </div>
                </>
              )}
            </FormGroup>
          </Col>
        </Row>
      </PageBody>
    </>
  );
};

const ValueText = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
  &.only-view {
    border-bottom: 1px solid #e2e7f1;
  }
`;
const ValueTextLabel = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
  color: #1c1d21;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  flex: 1;
`;
const ValueTextTotal = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
  color: #eda119;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  margin-left: 20px;
`;

const ValueTextTotalPayment = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #fd4858;
  margin-left: 20px;
`;

const ValueTextValue = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
  color: #1c1d21;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin-left: 20px;
`;

export default OrderAddInfo;
